














import Vue from "vue";
import { closeBrowser } from "@/utils/bridge";
import { UserInfo } from "@/utils/getUserInfo";
import { store } from "../services/store";

import SystemBarSpace from "./SystemBarSpace.vue";


export default Vue.extend({
  components: { SystemBarSpace },
  props: {
    bg: {
      // 背景色
      type: String,
      default: "#000000"
    },
    isShowRight: {
      // 是否显示右边的元素
      type: Boolean,
      default: true
    }
  },
  computed: {
    userInfo(): UserInfo {
      return store.userInfo;
    }
  },
  methods: {
    back() {
      const key = "danmaku-lottery-back";
      const value = localStorage.getItem(key);
      const mid = this.userInfo.mid || 0;
      /* 用户首次进入活动页，才弹出返回弹窗。但一个设备可能会登录多个用户 */
      if (!value) {
        // 没有缓存记录，弹出返回弹窗
        localStorage.setItem(key, JSON.stringify([ mid ]));
        this.$dialog.show("back");
      } else {
        const midList = JSON.parse(value);
        if (!(midList instanceof Array)) {
          localStorage.setItem(key, JSON.stringify([ mid ]));
          this.$dialog.show("back");
        } else if (midList.indexOf(mid) > -1) {
          // 如果当前mid的用户不是首次进入，不弹弹窗
          closeBrowser();
        } else {
          // 如果当前mid的用户是首次进入，弹弹窗
          midList.push(mid);
          localStorage.setItem(key, JSON.stringify(midList));
          this.$dialog.show("back");
        }
      }
    },
    share() {
      // 调起分享弹窗
      this.$emit("share");
    },
    quit() {
      this.$dialog.show("quit");
    }
  }
});
